"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const slice_1 = __importDefault(require("../app-reduxs/app/slice"));
const actions_1 = require("../app-reduxs/loginFirebase/actions");
const store_1 = require("../app-reduxs/store");
const constants_1 = __importDefault(require("../constants/constants"));
const rootNavigation_1 = require("../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../navigators/Routes"));
const AsyncStorage_1 = __importDefault(require("../utils/AsyncStorage"));
const timeout = 20000;
let refreshTokenRequest = null;
let dataRefresh = null;
const baseURL = react_native_1.Platform.OS == 'web' ? process.env.BASE_URL : react_native_config_1.default.BASE_URL;
const instance = axios_1.default.create({
    baseURL: baseURL,
    timeout,
});
const callRefreshToken = async (refresh_token) => {
    return axios_1.default.post(`${baseURL}/refresh-jwt`, { refresh_token }, {
        headers: {
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Access-Control-Allow-Headers': 'append,delete,entries,foreach,get,has,keys,set,values,Authorization',
            'Content-Type': 'application/json',
        },
    });
};
const handleError = (_message) => { };
const isShowCommonError = (error) => {
    const status = error?.response?.status || 500;
    return status !== 422 && status !== 401 && status !== 404;
};
instance.interceptors.request.use(async (config) => {
    // requestLog(config?.method!, config?.url!, config, 'req')
    const access_token = await AsyncStorage_1.default.get(constants_1.default.ACCESS_TOKEN_LOCAL);
    //@ts-ignore
    config.headers['Authorization'] = access_token == null ? '' : `Bearer ${access_token}`;
    return config;
}, (error) => {
    return Promise.reject(error);
});
instance.interceptors.response.use(async (response) => {
    // requestLog(response?.config?.method!, response?.config?.url!, response.data, 'res')
    return response;
}, async (error) => {
    // requestLog(error?.config?.method!, error?.config?.url!, error!, 'err')
    const status = error?.response?.status || 500;
    switch (status) {
        case 401:
            const refreshToken = await AsyncStorage_1.default.get(constants_1.default.REFRESH_TOKEN_LOCAL);
            if (dataRefresh == null && !!refreshToken) {
                refreshTokenRequest = refreshTokenRequest
                    ? refreshTokenRequest
                    : callRefreshToken(refreshToken);
                try {
                    dataRefresh = await refreshTokenRequest;
                    const data = dataRefresh?.data?.data;
                    // TRY TO FIX FIREBASE TOKEN EXPIRED
                    await AsyncStorage_1.default.remove(constants_1.default.FIREBASE_TOKEN);
                    store_1.store.dispatch((0, actions_1.refreshFirebaseAuth)());
                    AsyncStorage_1.default.set(constants_1.default.ACCESS_TOKEN_LOCAL, data?.token);
                    AsyncStorage_1.default.set(constants_1.default.REFRESH_TOKEN_LOCAL, data?.refresh_token);
                    error.response.config.headers['Authorization'] = 'Bearer ' + data?.token;
                    return (0, axios_1.default)(error.response.config);
                }
                catch (err) {
                    store_1.store.dispatch(slice_1.default.actions.setToastType(false));
                    store_1.store.dispatch(slice_1.default.actions.showToast('セッションが切れたため、再度ログインしてください。'));
                    store_1.store.dispatch(slice_1.default.actions.logout());
                }
                finally {
                    refreshTokenRequest = null;
                    dataRefresh = null;
                }
            }
            break;
        case 403:
            if (!error?.config?.url?.includes('mutes')) {
                (0, rootNavigation_1.replace)(Routes_1.default.AUTH_NAVIGATOR, { screen: Routes_1.default.LOGIN });
            }
            break;
        case 404:
            (0, rootNavigation_1.replace)(Routes_1.default.URL_NOT_FOUND);
            break;
        case 429:
            const message = error?.response?.data?.error?.message ??
                error?.response?.data?.message;
            store_1.store.dispatch(slice_1.default.actions.setToastType(false));
            store_1.store.dispatch(slice_1.default.actions.showToast(message));
            break;
        case 503:
            store_1.store.dispatch(slice_1.default.actions.showMaintainModal());
            break;
        default:
            if (isShowCommonError(error)) {
                const message = error?.response?.data?.error?.message ??
                    error?.response?.data?.message;
                if (message != null && message.trim().length > 0)
                    handleError(message);
            }
            break;
    }
    // if (status === 503) {
    // 	store.dispatch(appSlice.actions.showMaintainModal())
    // } else if (status === 403 && !error?.config?.url?.includes('mutes')) {
    // 	replace(Routes.AUTH_NAVIGATOR, { screen: Routes.LOGIN })
    // } else if (status === 401) {
    // 	const refreshToken = await AsyncStorage.get(constants.REFRESH_TOKEN_LOCAL)
    // 	refreshTokenRequest = refreshTokenRequest
    // 		? refreshTokenRequest
    // 		: callRefreshToken(refreshToken as string)
    // 	if (dataRefresh == null) {
    // 		try {
    // 			dataRefresh = await refreshTokenRequest
    // 			const data = dataRefresh?.data?.data
    // 			// TRY TO FIX FIREBASE TOKEN EXPIRED
    // 			await AsyncStorage.remove(constants.FIREBASE_TOKEN)
    // 			store.dispatch(refreshFirebaseAuth())
    // 			AsyncStorage.set(constants.ACCESS_TOKEN_LOCAL, data?.token)
    // 			AsyncStorage.set(constants.REFRESH_TOKEN_LOCAL, data?.refresh_token)
    // 			error.response.config.headers['Authorization'] = 'Bearer ' + data?.token
    // 			return axios(error.response.config)
    // 		} catch (err) {
    // 			store.dispatch(appSlice.actions.logout())
    // 		} finally {
    // 			refreshTokenRequest = null
    // 			dataRefresh = null
    // 		}
    // 	}
    // } else if (status == 429) {
    // 	const message =
    // 		error?.response?.data?.error?.message ?? (error?.response?.data?.message as string)
    // 	store.dispatch(appSlice.actions.setToastType(false))
    // 	store.dispatch(appSlice.actions.showToast(message))
    // } else if (isShowCommonError(error)) {
    // 	const message =
    // 		error?.response?.data?.error?.message ?? (error?.response?.data?.message as string)
    // 	if (message != null && message.trim().length > 0) handleError(message)
    // }
    return Promise.reject(error);
});
exports.default = instance;
